import React from 'react';
import { Typography } from 'antd';

const { Paragraph } = Typography;

const DirectionsList = ({ directions }) => {
  if (!directions) {
    return <Paragraph type="secondary">No directions provided.</Paragraph>;
  }

  // Check if directions contain HTML tags
  const containsHtml = /<[^>]+>/.test(directions);

  if (containsHtml) {
    // Render HTML content directly
    return (
      <div
        className="directions-html-content"
        dangerouslySetInnerHTML={{ __html: directions }}
      />
    );
  }

  // Split directions by newlines and number them for plain text
  const directionSteps = directions.split('\n').filter(line => line.trim());

  return (
    <div>
      {directionSteps.map((step, index) => {
        // Remove existing numbering if present (e.g., "1. Mix..." → "Mix...")
        // eslint-disable-next-line
        const cleanStep = step.replace(/^\d+[\.\)]\s*/, '').trim();

        return (
          <Paragraph key={index} style={{ marginBottom: '12px' }}>
            <strong>{index + 1}. </strong>
            {cleanStep}
          </Paragraph>
        );
      })}
    </div>
  );
};

export default DirectionsList;
